import { render, staticRenderFns } from "./insuranceAllied.vue?vue&type=template&id=432c7c30&scoped=true&"
import script from "./insuranceAllied.vue?vue&type=script&lang=js&"
export * from "./insuranceAllied.vue?vue&type=script&lang=js&"
import style0 from "./insuranceAllied.vue?vue&type=style&index=0&id=432c7c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432c7c30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VRow})
